module.exports = "<p>\n  place-holder works!\n</p>\n"